export const loadFacebookSDK = () => {
    const url = 'https://connect.facebook.net/en_US/sdk.js';
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = url;
    head.appendChild(script);
  };
  
  export const initializeFacebook = () => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: '853546249094105',
        autoLogAppEvents: true,
        cookie: true, // Enable cookies to allow the server to access the session.
        xfbml: true, // Parse social plugins on this webpage.
        version: 'v16.0' // Use this Graph API version for this call.
      });
    };
  };
  
  export const facebookLogout = () => {
    window.FB.api('/me/permissions', 'delete', null, () => window.FB.logout());
  };
  